export default __webpack_public_path__ + "55781244d7185bb94a3b8e17bed7e477.ttf";